import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-batch-add-members-file-requirements',
  templateUrl: './batch-add-members-file-requirements.component.html',
  styleUrls: ['./batch-add-members-file-requirements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchAddMembersFileRequirementsComponent {}
